export default __webpack_public_path__ + "static/moreMenuIcon-20f291de4d9f9a62a1794804e837b372.svg";